import { ICCar } from 'assets/icons';
import { PLANS } from 'global/plans';

import { IPlanCard } from './PlanCard/PlanCard';

export interface IBillingFeature {
  name: '';
  available: {
    basic: boolean | string;
    pro: boolean | string;
    premium: boolean | string;
  };
}

export const billingFeatures = (t: any): IBillingFeature[] => [
  {
    name: t('accountBilling:billingFeatures.0.name'),
    available: {
      basic: true,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.1.name'),
    available: {
      basic: true,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.2.name'),
    available: {
      basic: true,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.3.name'),
    available: {
      basic: '10 Users',
      pro: 'Unlimited',
      premium: 'Unlimited',
    },
  },
  {
    name: t('accountBilling:billingFeatures.4.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.5.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.6.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.7.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.8.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  // {
  //   name: t('accountBilling:billingFeatures.9.name'),
  //   available: {
  //     basic: false,
  //     pro: true,
  //     premium: true,
  //   },
  // },
  {
    name: t('accountBilling:billingFeatures.10.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.11.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.12.name'),
    available: {
      basic: false,
      pro: true,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.13.name'),
    available: {
      basic: false,
      pro: false,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.14.name'),
    available: {
      basic: false,
      pro: false,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.15.name'),
    available: {
      basic: false,
      pro: false,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.16.name'),
    available: {
      basic: false,
      pro: false,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.17.name'),
    available: {
      basic: false,
      pro: false,
      premium: true,
    },
  },
  {
    name: t('accountBilling:billingFeatures.18.name'),
    available: {
      basic: false,
      pro: false,
      premium: true,
    },
  },
];

type valueof<T> = T[keyof T];

export const billingPlans = (
  isYearly: boolean,
  durationType: 'monthly' | 'annual',
  currentPlan: valueof<typeof PLANS>,
  btnClickFn: (name: string, price: number) => void,
  toggleHasUpdatedPlan: () => void
): IPlanCard[] => {
  return [
    {
      heading: 'Basic',
      price: isYearly ? 44 : 4,
      isYearly: isYearly,
      desc: 'For basic time and mileage tracking',
      isCurrentPlan: currentPlan === PLANS.basic && (isYearly ? durationType === 'annual' : durationType === 'monthly'),
      isBestChoice: false,
      isSelected: currentPlan === PLANS.basic,
      onBtnClick: () => {
        btnClickFn('Basic', isYearly ? 44 : 4);
        toggleHasUpdatedPlan();
      },
    },
    {
      heading: 'Pro',
      price: isYearly ? 88 : 8,
      isYearly: isYearly,
      desc: 'Track jobs, integrations, and more',
      isCurrentPlan: currentPlan === PLANS.pro && (isYearly ? durationType === 'annual' : durationType === 'monthly'),
      isBestChoice: true,
      isSelected: currentPlan === PLANS.pro,
      onBtnClick: () => {
        btnClickFn('Pro', isYearly ? 88 : 8);
        toggleHasUpdatedPlan();
      },
    },
    {
      heading: 'Premium',
      price: isYearly ? 121 : 11,
      isYearly: isYearly,
      desc: 'Get the full package',
      isCurrentPlan:
        currentPlan === PLANS.premium && (isYearly ? durationType === 'annual' : durationType === 'monthly'),
      isBestChoice: false,
      isSelected: currentPlan === PLANS.premium,
      onBtnClick: () => {
        btnClickFn('Premium', isYearly ? 121 : 11);
        toggleHasUpdatedPlan();
      },
    },
  ];
};

export interface IAddOn {
  id: string;
  heading: string;
  headingIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  isNew?: boolean;
  price: {
    monthly: string | number;
    annually: string | number;
  };
  isYearly: boolean;
  descArray: string[];
}

export const addOnDetails = (isYearly: boolean, t: any): IAddOn[] => [
  {
    id: 'segmented_tracking',
    heading: t('accountBilling:segmentedTracking'),
    headingIcon: ICCar,
    isNew: true,
    price: {
      monthly: 5,
      annually: 55,
    },
    isYearly: isYearly,
    descArray: [
      'Automatically detect areas visited.',
      'Know the time spent at known and unknown locations.',
      'No more forgetting to track time and mileage excuses.',
    ],
  },
];

export const addOnIds: string[] = ['segmented_tracking'];
